module.exports = __webpack_public_path__ + "static/media/_title_15.37943868.svg";